(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[345],{

/***/ 1634:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(1929);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);





var Page = function(param) {
    var meta = param.meta, jsonLd = param.jsonLd, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    //! Url
    var url = "https://handle.am" + router.asPath;
    //! Title
    var title = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.title) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.title
    ]);
    //! Description
    var description = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (meta === null || meta === void 0 ? void 0 : meta.description) || "Handle Brand Armenia";
    }, [
        meta === null || meta === void 0 ? void 0 : meta.description
    ]);
    //! Image
    var image = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            url: (meta === null || meta === void 0 ? void 0 : meta.image) || "https://handle.am" + "/handle-logo.png",
            alt: title
        };
    }, [
        meta === null || meta === void 0 ? void 0 : meta.image
    ]);
    //! Ld Json
    var ldJson = jsonLd || {
        "@context": "http://schema.org/",
        "@type": "Organization",
        name: "Handle Brand Armenia",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Yerevan, Buzand 1/3",
            addressLocality: "Yerevan",
            addressRegion: "Yerevan"
        },
        telephone: "+374 33 58 58 50"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                canonical: url,
                type: "website",
                openGraph: {
                    url: url,
                    title: title,
                    description: description,
                    images: [
                        image
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 9070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ productItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/icons/add-to-cart.png
/* harmony default export */ var add_to_cart = ({"src":"/_next/static/media/add-to-cart.72803f29.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAbUlEQVR42g3EIQ5BcQAH4F/AVMkJFFMpdNMEQbJJzEZAEJzBBYzgFC+9OYJ3oW/++7YvIjbeXuVIdMzVJkVtrhNbjcqtqDS2cXAyFTFztI+LpegWsXaPs5Voa4m+UVwtRGHoqRc7Xw8fJ2M/gz9GP1Mdk9tBnQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/icons/added-to-cart.png
/* harmony default export */ var added_to_cart = ({"src":"/_next/static/media/added-to-cart.d54ddace.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcklEQVR42h3NP8oBAAAH0N/69Y1GgwxiIya5gs2kDE6gLHaT2AxOYlDyd5EoGXGYl9I7wIuNo72ti7moxEdVQ1Pbn75H7BTlp+fuP9YmtmLgqaMWV7HwchNjyziLGCqIkWm8NbSU1JWtzGJjb+fk8Ku7X+TWWnrsh0F0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/redux/global.slice.js
var global_slice = __webpack_require__(66);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./src/helpers/basket.helper.js
var basket_helper = __webpack_require__(8769);
// EXTERNAL MODULE: ./src/helpers/cookie.helpers.js
var cookie_helpers = __webpack_require__(2881);
;// CONCATENATED MODULE: ./src/components/productItem.js














var ProductItem = function(param) {
    var image = param.image, name = param.name, code = param.code, size = param.size, price = param.price, tag = param.tag, oldPriceData = param.oldPriceData, id = param.id, currency = param.currency, changeSize = param.changeSize, minPrice = param.minPrice, maxPrice = param.maxPrice;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), sizeState = ref2[0], setSizeState = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(null), basketData = ref3[0], setBasketData = ref3[1];
    var intl = (0,useIntl/* default */.Z)();
    var priceData = price * tag;
    var priceOld = Math.round(priceData / 100);
    var newPrice = price - priceOld;
    var basket = (0,es/* useSelector */.v9)(function(state) {
        return state.global.basket;
    });
    var basketDataReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var basketReq, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* basket_req */.Cl)(basket)
                        ];
                    case 1:
                        basketReq = _state.sent();
                        setBasketData(basketReq);
                        data = (0,cookie_helpers/* getCookie */.ej)("basket");
                        if (basketReq) {
                            dispatch((0,global_slice/* changeBasketCount */.zW)(data === null || data === void 0 ? void 0 : data.length));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function basketDataReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var addBasket = function() {
        basketDataReq();
        (0,basket_helper/* addRemoveFromBasket */.cQ)(id, 1, intl.messages.product_successfully_added, intl.messages.product_successfully_removed);
    // const dataFilter = basketData?.find((item) => item.id === id);
    };
    (0,react.useEffect)(function() {
        if (typeof size === "string") {
            setSizeState(JSON.parse(size ? size : null));
        } else {
            setSizeState(size);
        }
    }, [
        size
    ]);
    var defaultImage = "https://via.placeholder.com/1000x1000/f3f3f3/f3f3f3/?text=.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-item mb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-image",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: defaultImage,
                                    alt: name
                                }),
                                tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "tag",
                                    children: [
                                        "-",
                                        tag,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    }),
                    !basketData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "cart-button",
                        onClick: addBasket,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.addBasket
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: add_to_cart.src,
                                alt: "Add To Cart"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: intl.messages.productAdded
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: added_to_cart.src,
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                className: "product-name mb-10",
                href: ("/product?id=".concat(id, "&changeSize=").concat(changeSize, "&minPrice=").concat(minPrice, "&maxPrice=").concat(maxPrice), "/product?id=".concat(id)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "product-name",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-ai-end flex-jc-between p-20 pl-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "product-info",
                            children: [
                                code && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.code,
                                        ": ",
                                        code
                                    ]
                                }),
                                (sizeState === null || sizeState === void 0 ? void 0 : (ref = sizeState[0]) === null || ref === void 0 ? void 0 : ref.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        intl.messages.size,
                                        ": ",
                                        (sizeState === null || sizeState === void 0 ? void 0 : (ref1 = sizeState[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || (sizeState === null || sizeState === void 0 ? void 0 : sizeState.name)
                                    ]
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-prices",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-price",
                                children: [
                                    tag ? newPrice : price,
                                    " ",
                                    currency
                                ]
                            }),
                            oldPriceData && price && tag > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-oldPrice",
                                children: [
                                    price,
                                    " ",
                                    currency
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var productItem = (ProductItem);


/***/ }),

/***/ 8511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var Title = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "title",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            children: title
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 8769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EG": function() { return /* binding */ incrementProduct; },
/* harmony export */   "Zg": function() { return /* binding */ decrementProduct; },
/* harmony export */   "cQ": function() { return /* binding */ addRemoveFromBasket; }
/* harmony export */ });
/* unused harmony export changeCountForProduct */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7582);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(977);
/* harmony import */ var _cookie_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2881);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2920);







function addRemoveFromBasket(id, count, addMessage, removeMessage) {
    var existingBasket = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
    if (!existingBasket) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify([
            id
        ]));
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, id, count)));
        react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        return;
    }
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    try {
        existingBasket = JSON.parse(existingBasket);
        productsCount = JSON.parse(productsCount);
        var indexInBasket = existingBasket.indexOf(id);
        if (indexInBasket === -1) {
            productsCount[id] = count;
            existingBasket.push(id);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(addMessage);
        } else {
            if (existingBasket.length === 1) {
                var basketDataReq = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        var basketReq, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        (0,_api_api__WEBPACK_IMPORTED_MODULE_0__/* .basket_req */ .Cl)(existingBasket)
                                    ];
                                case 1:
                                    basketReq = _state.sent();
                                    data = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("basket");
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    e = _state.sent();
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function basketDataReq() {
                        return _ref.apply(this, arguments);
                    };
                }();
                basketDataReq();
                react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
                (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
                window.location.reload();
                return;
            }
            delete productsCount[id];
            existingBasket.splice(indexInBasket, 1);
            react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(removeMessage);
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("basket", JSON.stringify(existingBasket));
            (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
        }
    } catch (e) {
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function incrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]++;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
function decrementProduct(id) {
    var productsCount = (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)("productsCount");
    if (!productsCount) {
        return;
    }
    try {
        productsCount = JSON.parse(productsCount);
        productsCount[id]--;
        if (productsCount[id] === 0) {
            delete productsCount[id];
        }
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("productsCount", JSON.stringify(productsCount));
    } catch (e) {
        ;
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("basket");
        (0,_cookie_helpers__WEBPACK_IMPORTED_MODULE_2__/* .deleteCookie */ .kT)("productsCount");
    }
}
var changeCountForProduct = function() {
    var countObj = _object_spread({}, state.productsCount);
    countObj[action.payload.productId] = action.payload.count;
    setCookie("productsCount", JSON.stringify(countObj));
    state.productsCount = countObj;
};


/***/ }),

/***/ 1929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(797);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./src/components/Page/index.js
var Page = __webpack_require__(7558);
// EXTERNAL MODULE: ./src/elements/title.js
var title = __webpack_require__(8511);
// EXTERNAL MODULE: ./src/components/productItem.js + 2 modules
var components_productItem = __webpack_require__(9070);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/react-inner-image-zoom/lib/InnerImageZoom/styles.min.css
var styles_min = __webpack_require__(4300);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/Image.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }




var Image = function Image(_ref) {
  var src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      imgAttributes = _ref.imgAttributes,
      isZoomed = _ref.isZoomed,
      fadeDuration = _ref.fadeDuration;
  var createSpacer = width && height && hasSpacer;
  return /*#__PURE__*/react.createElement("div", {
    style: {
      paddingTop: createSpacer ? height / width * 100 + "%" : null
    }
  }, sources && sources.length > 0 ? /*#__PURE__*/react.createElement("picture", null, sources.map(function (source, i) {
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: i
    }, source.srcSet && /*#__PURE__*/react.createElement("source", source));
  }), /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  }))) : /*#__PURE__*/react.createElement("img", _extends({}, imgAttributes, {
    className: "iiz__img " + (imgAttributes.className || '') + " " + (isZoomed ? 'iiz__img--hidden' : '') + " " + (createSpacer ? 'iiz__img--abs' : ''),
    style: {
      transition: "opacity 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms, visibility 0ms linear " + (isZoomed ? fadeDuration : 0) + "ms"
    },
    src: src,
    width: width,
    height: height
  })));
};

Image.propTypes =  false ? 0 : {};
/* harmony default export */ var components_Image = (Image);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/ZoomImage.js



var ZoomImage = function ZoomImage(_ref) {
  var src = _ref.src,
      fadeDuration = _ref.fadeDuration,
      top = _ref.top,
      left = _ref.left,
      isZoomed = _ref.isZoomed,
      onLoad = _ref.onLoad,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onClose = _ref.onClose,
      onFadeOut = _ref.onFadeOut;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("img", {
    className: "iiz__zoom-img " + (isZoomed ? 'iiz__zoom-img--visible' : ''),
    style: {
      top: top,
      left: left,
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    src: src,
    onLoad: onLoad,
    onTouchStart: onDragStart,
    onTouchEnd: onDragEnd,
    onMouseDown: onDragStart,
    onMouseUp: onDragEnd,
    onTransitionEnd: onFadeOut,
    draggable: "false",
    alt: ""
  }), onClose && /*#__PURE__*/react.createElement("button", {
    className: "iiz__btn iiz__close " + (isZoomed ? 'iiz__close--visible' : ''),
    style: {
      transition: "opacity " + fadeDuration + "ms linear, visibility " + fadeDuration + "ms linear"
    },
    onClick: onClose,
    "aria-label": "Zoom Out"
  }));
};

ZoomImage.propTypes =  false ? 0 : {};
/* harmony default export */ var components_ZoomImage = (ZoomImage);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/components/FullscreenPortal.js




var FullscreenPortal = function FullscreenPortal(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(function () {
    var el = document.createElement('div');
    el.classList.add('iiz__zoom-portal');
    return el;
  }),
      portal = _useState[0];

  (0,react.useEffect)(function () {
    document.body.appendChild(portal);
    return function () {
      return document.body.removeChild(portal);
    };
  }, [portal]);
  return (0,react_dom.createPortal)(children, portal);
};

FullscreenPortal.propTypes = {
  children: (prop_types_default()).element
};
/* harmony default export */ var components_FullscreenPortal = (FullscreenPortal);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/InnerImageZoom.js
var _this = undefined;







var InnerImageZoom = function InnerImageZoom(_ref) {
  var _ref$moveType = _ref.moveType,
      moveType = _ref$moveType === void 0 ? 'pan' : _ref$moveType,
      _ref$zoomType = _ref.zoomType,
      zoomType = _ref$zoomType === void 0 ? 'click' : _ref$zoomType,
      src = _ref.src,
      sources = _ref.sources,
      width = _ref.width,
      height = _ref.height,
      hasSpacer = _ref.hasSpacer,
      _ref$imgAttributes = _ref.imgAttributes,
      imgAttributes = _ref$imgAttributes === void 0 ? {} : _ref$imgAttributes,
      zoomSrc = _ref.zoomSrc,
      _ref$zoomScale = _ref.zoomScale,
      zoomScale = _ref$zoomScale === void 0 ? 1 : _ref$zoomScale,
      zoomPreload = _ref.zoomPreload,
      _ref$fadeDuration = _ref.fadeDuration,
      fadeDuration = _ref$fadeDuration === void 0 ? 150 : _ref$fadeDuration,
      fullscreenOnMobile = _ref.fullscreenOnMobile,
      _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? 640 : _ref$mobileBreakpoint,
      hideCloseButton = _ref.hideCloseButton,
      hideHint = _ref.hideHint,
      className = _ref.className,
      afterZoomIn = _ref.afterZoomIn,
      afterZoomOut = _ref.afterZoomOut;
  var img = (0,react.useRef)(null);
  var zoomImg = (0,react.useRef)(null);
  var imgProps = (0,react.useRef)({});

  var _useState = (0,react.useState)(zoomPreload),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTouch = _useState2[0],
      setIsTouch = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isZoomed = _useState3[0],
      setIsZoomed = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isFullscreen = _useState4[0],
      setIsFullscreen = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isDragging = _useState5[0],
      setIsDragging = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isValidDrag = _useState6[0],
      setIsValidDrag = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isFading = _useState7[0],
      setIsFading = _useState7[1];

  var _useState8 = (0,react.useState)(moveType),
      currentMoveType = _useState8[0],
      setCurrentMoveType = _useState8[1];

  var _useState9 = (0,react.useState)(0),
      left = _useState9[0],
      setLeft = _useState9[1];

  var _useState10 = (0,react.useState)(0),
      top = _useState10[0],
      setTop = _useState10[1];

  var handleMouseEnter = function handleMouseEnter(e) {
    setIsActive(true);
    setIsFading(false);
    zoomType === 'hover' && !isZoomed && handleClick(e);
  };

  var handleTouchStart = function handleTouchStart() {
    setIsTouch(true);
    setIsFullscreen(getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint));
    setCurrentMoveType('drag');
  };

  var handleClick = function handleClick(e) {
    if (isZoomed) {
      if (isTouch) {
        hideCloseButton && handleClose(e);
      } else {
        !isValidDrag && zoomOut();
      }

      return;
    }

    isTouch && setIsActive(true);

    if (zoomImg.current) {
      handleLoad({
        target: zoomImg.current
      });
      zoomIn(e.pageX, e.pageY);
    } else {
      imgProps.current.onLoadCallback = zoomIn.bind(_this, e.pageX, e.pageY);
    }
  };

  var handleLoad = function handleLoad(e) {
    var scaledDimensions = getScaledDimensions(e.target, zoomScale);
    zoomImg.current = e.target;
    zoomImg.current.setAttribute('width', scaledDimensions.width);
    zoomImg.current.setAttribute('height', scaledDimensions.height);
    imgProps.current.scaledDimensions = scaledDimensions;
    imgProps.current.bounds = getBounds(img.current, false);
    imgProps.current.ratios = getRatios(imgProps.current.bounds, scaledDimensions);

    if (imgProps.current.onLoadCallback) {
      imgProps.current.onLoadCallback();
      imgProps.current.onLoadCallback = null;
    }
  };

  var handleMouseMove = function handleMouseMove(e) {
    var left = e.pageX - imgProps.current.offsets.x;
    var top = e.pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, imgProps.current.bounds.width), 0);
    top = Math.max(Math.min(top, imgProps.current.bounds.height), 0);
    setLeft(left * -imgProps.current.ratios.x);
    setTop(top * -imgProps.current.ratios.y);
  };

  var handleDragStart = function handleDragStart(e) {
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    imgProps.current.offsets = getOffsets(pageX, pageY, zoomImg.current.offsetLeft, zoomImg.current.offsetTop);
    setIsDragging(true);

    if (!isTouch) {
      imgProps.current.eventPosition = {
        x: e.pageX,
        y: e.pageY
      };
    }
  };

  var handleDragMove = (0,react.useCallback)(function (e) {
    e.stopPropagation();
    var pageX = typeof e.pageX === 'number' ? e.pageX : e.changedTouches[0].pageX;
    var pageY = typeof e.pageY === 'number' ? e.pageY : e.changedTouches[0].pageY;
    var left = pageX - imgProps.current.offsets.x;
    var top = pageY - imgProps.current.offsets.y;
    left = Math.max(Math.min(left, 0), (imgProps.current.scaledDimensions.width - imgProps.current.bounds.width) * -1);
    top = Math.max(Math.min(top, 0), (imgProps.current.scaledDimensions.height - imgProps.current.bounds.height) * -1);
    setLeft(left);
    setTop(top);
  }, []);

  var handleDragEnd = function handleDragEnd(e) {
    setIsDragging(false);

    if (!isTouch) {
      var moveX = Math.abs(e.pageX - imgProps.current.eventPosition.x);
      var moveY = Math.abs(e.pageY - imgProps.current.eventPosition.y);
      setIsValidDrag(moveX > 5 || moveY > 5);
    }
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    currentMoveType === 'drag' && isZoomed ? handleDragEnd(e) : handleClose(e);
  };

  var handleClose = function handleClose(e) {
    if (!(!isTouch && e.target.classList.contains('iiz__close'))) {
      if (!isZoomed || isFullscreen || !fadeDuration) {
        handleFadeOut({}, true);
      } else {
        setIsFading(true);
      }
    }

    zoomOut();
  };

  var handleFadeOut = function handleFadeOut(e, noTransition) {
    if (noTransition || e.propertyName === 'opacity' && img.current.contains(e.target)) {
      if (zoomPreload && isTouch || !zoomPreload) {
        zoomImg.current = null;
        imgProps.current = getDefaults();
        setIsActive(false);
      }

      setIsTouch(false);
      setIsFullscreen(false);
      setCurrentMoveType(moveType);
      setIsFading(false);
    }
  };

  var initialMove = function initialMove(pageX, pageY) {
    imgProps.current.offsets = getOffsets(window.pageXOffset, window.pageYOffset, -imgProps.current.bounds.left, -imgProps.current.bounds.top);
    handleMouseMove({
      pageX: pageX,
      pageY: pageY
    });
  };

  var initialDrag = function initialDrag(pageX, pageY) {
    var initialPageX = (pageX - (window.pageXOffset + imgProps.current.bounds.left)) * -imgProps.current.ratios.x;
    var initialPageY = (pageY - (window.pageYOffset + imgProps.current.bounds.top)) * -imgProps.current.ratios.y;
    initialPageX = initialPageX + (isFullscreen ? (window.innerWidth - imgProps.current.bounds.width) / 2 : 0);
    initialPageY = initialPageY + (isFullscreen ? (window.innerHeight - imgProps.current.bounds.height) / 2 : 0);
    imgProps.current.bounds = getBounds(img.current, isFullscreen);
    imgProps.current.offsets = getOffsets(0, 0, 0, 0);
    handleDragMove({
      changedTouches: [{
        pageX: initialPageX,
        pageY: initialPageY
      }],
      preventDefault: function preventDefault() {},
      stopPropagation: function stopPropagation() {}
    });
  };

  var zoomIn = function zoomIn(pageX, pageY) {
    setIsZoomed(true);
    currentMoveType === 'drag' ? initialDrag(pageX, pageY) : initialMove(pageX, pageY);
    afterZoomIn && afterZoomIn();
  };

  var zoomOut = function zoomOut() {
    setIsZoomed(false);
    afterZoomOut && afterZoomOut();
  };

  var getDefaults = function getDefaults() {
    return {
      onLoadCallback: null,
      bounds: {},
      offsets: {},
      ratios: {},
      eventPosition: {},
      scaledDimensions: {}
    };
  };

  var getBounds = function getBounds(img, isFullscreen) {
    if (isFullscreen) {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
        left: 0,
        top: 0
      };
    }

    return img.getBoundingClientRect();
  };

  var getOffsets = function getOffsets(pageX, pageY, left, top) {
    return {
      x: pageX - left,
      y: pageY - top
    };
  };

  var getRatios = function getRatios(bounds, dimensions) {
    return {
      x: (dimensions.width - bounds.width) / bounds.width,
      y: (dimensions.height - bounds.height) / bounds.height
    };
  };

  var getFullscreenStatus = function getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) {
    return fullscreenOnMobile && window.matchMedia && window.matchMedia("(max-width: " + mobileBreakpoint + "px)").matches;
  };

  var getScaledDimensions = function getScaledDimensions(zoomImg, zoomScale) {
    return {
      width: zoomImg.naturalWidth * zoomScale,
      height: zoomImg.naturalHeight * zoomScale
    };
  };

  var zoomImageProps = {
    src: zoomSrc || src,
    fadeDuration: isFullscreen ? 0 : fadeDuration,
    top: top,
    left: left,
    isZoomed: isZoomed,
    onLoad: handleLoad,
    onDragStart: currentMoveType === 'drag' ? handleDragStart : null,
    onDragEnd: currentMoveType === 'drag' ? handleDragEnd : null,
    onClose: !hideCloseButton && currentMoveType === 'drag' ? handleClose : null,
    onFadeOut: isFading ? handleFadeOut : null
  };
  (0,react.useEffect)(function () {
    imgProps.current = getDefaults();
  }, []);
  (0,react.useEffect)(function () {
    getFullscreenStatus(fullscreenOnMobile, mobileBreakpoint) && setIsActive(false);
  }, [fullscreenOnMobile, mobileBreakpoint]);
  (0,react.useEffect)(function () {
    if (!zoomImg.current) {
      return;
    }

    var eventType = isTouch ? 'touchmove' : 'mousemove';

    if (isDragging) {
      zoomImg.current.addEventListener(eventType, handleDragMove, {
        passive: true
      });
    } else {
      zoomImg.current.removeEventListener(eventType, handleDragMove);
    }
  }, [isDragging, isTouch, handleDragMove]);
  return /*#__PURE__*/react.createElement("figure", {
    className: "iiz " + (currentMoveType === 'drag' ? 'iiz--drag' : '') + " " + (className ? className : ''),
    style: {
      width: width
    },
    ref: img,
    onTouchStart: isZoomed ? null : handleTouchStart,
    onClick: handleClick,
    onMouseEnter: isTouch ? null : handleMouseEnter,
    onMouseMove: currentMoveType === 'drag' || !isZoomed ? null : handleMouseMove,
    onMouseLeave: isTouch ? null : handleMouseLeave
  }, /*#__PURE__*/react.createElement(components_Image, {
    src: src,
    sources: sources,
    width: width,
    height: height,
    hasSpacer: hasSpacer,
    imgAttributes: imgAttributes,
    fadeDuration: fadeDuration,
    isZoomed: isZoomed
  }), isActive && /*#__PURE__*/react.createElement(react.Fragment, null, isFullscreen ? /*#__PURE__*/react.createElement(components_FullscreenPortal, null, /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)) : /*#__PURE__*/react.createElement(components_ZoomImage, zoomImageProps)), !hideHint && !isZoomed && /*#__PURE__*/react.createElement("span", {
    className: "iiz__btn iiz__hint"
  }));
};

InnerImageZoom.propTypes =  false ? 0 : {};
/* harmony default export */ var InnerImageZoom_InnerImageZoom = (InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/InnerImageZoom/index.js

/* harmony default export */ var es_InnerImageZoom = (InnerImageZoom_InnerImageZoom);
;// CONCATENATED MODULE: ./node_modules/react-inner-image-zoom/es/index.js

/* harmony default export */ var react_inner_image_zoom_es = (es_InnerImageZoom);

;// CONCATENATED MODULE: ./src/components/slider.js









var AsNavFor = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AsNavFor, Component);
    var _super = _createSuper(AsNavFor);
    function AsNavFor(props) {
        _classCallCheck(this, AsNavFor);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            nav1: null,
            nav2: null
        };
        return _this;
    }
    _createClass(AsNavFor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    nav1: this.slider1,
                    nav2: this.slider2
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            asNavFor: this.state.nav2,
                            ref: function(slider) {
                                return _this.slider1 = slider;
                            },
                            className: "slick-for",
                            children: (ref = this.props.productImages) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "slide-item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_inner_image_zoom_es, {
                                        src: item.image,
                                        zoomSrc: item.image
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            asNavFor: this.state.nav1,
                            ref: function(slider) {
                                return _this.slider2 = slider;
                            },
                            slidesToShow: 3,
                            swipeToSlide: true,
                            focusOnSelect: true,
                            className: "slick-nav",
                            infinite: false,
                            responsive: [
                                {
                                    breakpoint: 640,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                }
                            ],
                            children: (ref1 = this.props.productImages) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: item.image
                                    })
                                }, index);
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return AsNavFor;
}(react.Component);


// EXTERNAL MODULE: ./src/helpers/basket.helper.js
var basket_helper = __webpack_require__(8769);
// EXTERNAL MODULE: ./src/helpers/cookie.helpers.js
var cookie_helpers = __webpack_require__(2881);
// EXTERNAL MODULE: ./src/redux/global.slice.js
var global_slice = __webpack_require__(66);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.js



var Breadcrumbs = function(param) {
    var currentPage = param.currentPage, _className = param.className, className = _className === void 0 ? "" : _className;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var goHome = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "breadcrumbs-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "breadcrumbs ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: goHome,
                        children: intl.messages.home
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: currentPage
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./src/pages/product.js


















var Product = function(query) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var basketCount = (0,es/* useSelector */.v9)(function(state) {
        return state.global.basket;
    });
    var ref6 = (0,react.useState)(null), favoriteData = ref6[0], setFavoriteData = ref6[1];
    var ref7 = (0,react.useState)(null), productImages = ref7[0], setProductImages = ref7[1];
    var ref8 = (0,react.useState)(null), sizeData = ref8[0], setSizeData = ref8[1];
    var ref9 = (0,react.useState)(null), basketData = ref9[0], setBasketData = ref9[1];
    var ref10 = (0,react.useState)(false), addBasketBtn = ref10[0], setAddBasketBtn = ref10[1];
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.global.locale;
    });
    var ref11 = (0,react.useState)(null), productItem = ref11[0], setProductItem = ref11[1];
    var ref12 = (0,react.useState)(null), coockieData = ref12[0], setCoockieData = ref12[1];
    var ref13 = (0,react.useState)(1), count = ref13[0], setCount = ref13[1];
    var productItemReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var productData, ref, ref1, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* getProductsItem_req */._r)(query.id)
                        ];
                    case 1:
                        productData = _state.sent();
                        if (productData) {
                            ;
                            setProductImages((productData === null || productData === void 0 ? void 0 : (ref = productData.product) === null || ref === void 0 ? void 0 : ref.images) ? JSON.parse(productData === null || productData === void 0 ? void 0 : (ref1 = productData.product) === null || ref1 === void 0 ? void 0 : ref1.images) : null);
                            setSizeData(JSON.parse(productData === null || productData === void 0 ? void 0 : (ref2 = productData.product) === null || ref2 === void 0 ? void 0 : ref2.size));
                        }
                        setProductItem(productData);
                        return [
                            2
                        ];
                }
            });
        });
        return function productItemReq() {
            return _ref.apply(this, arguments);
        };
    }();
    var basketDataReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var basketReq, data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* basket_req */.Cl)(basketCount)
                        ];
                    case 1:
                        basketReq = _state.sent();
                        data = (0,cookie_helpers/* getCookie */.ej)("basket");
                        setBasketData(basketReq);
                        if (basketReq) {
                            dispatch((0,global_slice/* changeBasketCount */.zW)(data === null || data === void 0 ? void 0 : data.length));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function basketDataReq() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if ((basketCount === null || basketCount === void 0 ? void 0 : basketCount.length) > 0) {
            basketDataReq();
        }
    }, [
        basketCount
    ]);
    (0,react.useEffect)(function() {
        var data = (0,cookie_helpers/* getCookie */.ej)("productsCount");
        setCoockieData(JSON.parse(data));
    }, []);
    (0,react.useEffect)(function() {
        setAddBasketBtn(false);
        setCount(1);
    }, [
        query
    ]);
    var countData = coockieData && coockieData[productItem === null || productItem === void 0 ? void 0 : (ref = productItem.product) === null || ref === void 0 ? void 0 : ref.id];
    var favoriteProducts = productItem === null || productItem === void 0 ? void 0 : productItem.favoriteProducts;
    var producted = productItem === null || productItem === void 0 ? void 0 : productItem.product;
    // const totalCount = count * producted?.price;
    var countObj = [];
    var featuredProductsReq = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,api/* getFeautered_req */.i6)()
                        ];
                    case 1:
                        response = _state.sent();
                        setFavoriteData(response === null || response === void 0 ? void 0 : response.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function featuredProductsReq() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        productItemReq();
        featuredProductsReq();
    }, [
        query.id,
        locale
    ]);
    var plusCount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(count) {
            var _JSON, id, dataCount;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setCount(count);
                id = producted === null || producted === void 0 ? void 0 : producted.id;
                dataCount = localStorage.getItem(countObj);
                if (dataCount === null) {
                    countObj.push({
                        id: id,
                        count: count
                    });
                } else {
                    countObj.push((0,_to_consumable_array/* default */.Z)(dataCount).concat([
                        {
                            id: id,
                            count: count
                        }
                    ]));
                }
                localStorage.setItem("countObj", (_JSON = JSON).stringify.apply(_JSON, (0,_to_consumable_array/* default */.Z)(countObj)));
                return [
                    2
                ];
            });
        // dispatch(
        //   changeCountForProduct({
        //     productId: producted?.id,
        //   })
        // );
        });
        return function plusCount(count) {
            return _ref.apply(this, arguments);
        };
    }();
    var minusCount = function(count) {
        if (count > 1) {
            setCount(count);
        } else {
            setCount(1);
        }
    };
    var updateProductPage = function(id) {
        setCount(1);
        setAddBasketBtn(false);
        router.push("/product?&id=".concat(id));
    };
    var addBasket = function(id, count) {
        basketDataReq();
        setAddBasketBtn(!addBasketBtn);
        (0,basket_helper/* addRemoveFromBasket */.cQ)(id, count, intl.messages.product_successfully_added, intl.messages.product_successfully_removed);
    };
    var dataFilterProducts = basketData === null || basketData === void 0 ? void 0 : basketData.find(function(item) {
        return item.id == query.id;
    });
    var productPrice = count * (producted === null || producted === void 0 ? void 0 : producted.price);
    var discountPrice = productPrice * 10 / 100;
    var priceDiscount = productPrice - discountPrice;
    return producted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        meta: {
            title: producted === null || producted === void 0 ? void 0 : producted.title,
            description: producted === null || producted === void 0 ? void 0 : producted.description,
            image: productImages === null || productImages === void 0 ? void 0 : (ref1 = productImages[0]) === null || ref1 === void 0 ? void 0 : ref1.image
        },
        jsonLd: {
            "@context": "https://schema.org/",
            "@type": "Product",
            name: producted === null || producted === void 0 ? void 0 : producted.title,
            description: producted === null || producted === void 0 ? void 0 : producted.description,
            image: productImages === null || productImages === void 0 ? void 0 : productImages.map(function(item) {
                return item.image;
            })
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "stylesheet",
                    type: "text/css",
                    charSet: "UTF-8",
                    href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Breadcrumbs, {
                            currentPage: producted === null || producted === void 0 ? void 0 : producted.title,
                            className: "product-page"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-content flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-gallery",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsNavFor, {
                                        productImages: productImages
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "code",
                                            children: [
                                                intl.messages.code,
                                                ": ",
                                                producted === null || producted === void 0 ? void 0 : producted.code
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "name",
                                            children: producted === null || producted === void 0 ? void 0 : producted.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                (sizeData === null || sizeData === void 0 ? void 0 : (ref2 = sizeData[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                intl.messages.size,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: sizeData === null || sizeData === void 0 ? void 0 : (ref3 = sizeData[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                                                        })
                                                    ]
                                                }),
                                                (producted === null || producted === void 0 ? void 0 : producted.weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                intl.messages.weight,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                            children: [
                                                                producted === null || producted === void 0 ? void 0 : producted.weight,
                                                                " ",
                                                                intl.messages.kg
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                (producted === null || producted === void 0 ? void 0 : producted.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                intl.messages.category,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: producted === null || producted === void 0 ? void 0 : (ref4 = producted.categoryList) === null || ref4 === void 0 ? void 0 : ref4[0].name
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "description",
                                            children: producted === null || producted === void 0 ? void 0 : producted.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex mb-60",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "count",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "field-name",
                                                            children: intl.messages.quantity
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "quantity",
                                                            children: [
                                                                dataFilterProducts || addBasketBtn ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    onClick: function() {
                                                                        return minusCount(count - 1);
                                                                    },
                                                                    children: "-"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "quantity-number",
                                                                    children: countData ? countData : count
                                                                }),
                                                                dataFilterProducts || addBasketBtn ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    onClick: function() {
                                                                        return plusCount(count + 1);
                                                                    },
                                                                    children: "+"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "price",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "field-name",
                                                            children: intl.messages.price
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: count > 4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                        className: "old-price",
                                                                        children: [
                                                                            productPrice,
                                                                            " ",
                                                                            producted === null || producted === void 0 ? void 0 : producted.currency
                                                                        ]
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                        children: [
                                                                            priceDiscount,
                                                                            " ",
                                                                            producted === null || producted === void 0 ? void 0 : producted.currency
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                                children: [
                                                                    productPrice,
                                                                    " ",
                                                                    producted === null || producted === void 0 ? void 0 : producted.currency
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        dataFilterProducts ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "added-basket-button",
                                            children: intl.messages.productAdded
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "add-basket-button",
                                            onClick: function() {
                                                return addBasket(producted === null || producted === void 0 ? void 0 : producted.id, count);
                                            },
                                            children: intl.messages.addBasket
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-info",
                                            children: [
                                                "* ",
                                                intl.messages.discount_text
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "products pt-40 pb-40",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                    title: intl.messages.favoriteProducts
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-wrap",
                                    children: favoriteData === null || favoriteData === void 0 ? void 0 : (ref5 = favoriteData.featuredProducts) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_productItem/* default */.Z, {
                                            image: item.image,
                                            name: item.title,
                                            size: item.size,
                                            price: item.price,
                                            code: item.code,
                                            categoryName: item.categoryName,
                                            tag: item === null || item === void 0 ? void 0 : item.discount,
                                            oldPriceData: true,
                                            id: item.id,
                                            currency: item.currency,
                                            updateProductPage: updateProductPage
                                        }, item.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }) : null;
};
Product.getInitialProps = function(param) {
    var query = param.query;
    return query;
};
/* harmony default export */ var product = (Product);


/***/ }),

/***/ 4300:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,66,774,888,179], function() { return __webpack_exec__(1634); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);